import { toast } from "react-toastify"

// The backend malware-scan download gate blocks a not-yet-clean object with HTTP 409 and this code
// (see the central handler in services/verified-id/index.js). Surface one friendly "still scanning"
// message for the whole app instead of a raw error, then re-reject so each caller can still stop its
// own spinner / handle state. The shared toastId collapses bursts (e.g. a list of several files) into
// a single toast.
export const MALWARE_SCAN_NOT_CLEAN = "MALWARE_SCAN_NOT_CLEAN"

export const isMalwareScanBlocked = (error) =>
    error?.response?.status === 409 && error?.response?.data?.code === MALWARE_SCAN_NOT_CLEAN

export const handleMalwareScanBlocked = (error) => {
    if (isMalwareScanBlocked(error)) {
        // The gate blocks both "still scanning" and "flagged unsafe" with the same 409; the
        // scanStatus tells them apart so the message (and severity) matches.
        const scanStatus = error?.response?.data?.scanStatus

        if (scanStatus === "infected") {
            toast.error(
                "This file was flagged as unsafe and cannot be opened. Please upload a different file.",
                { toastId: "malware-scan-infected" },
            )
        }
        else {
            toast.info(
                "This file is still being security-scanned. Please try again in a moment.",
                { toastId: "malware-scan-pending" },
            )
        }
    }
    return Promise.reject(error)
}
